import { Module } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { MessageBroadcastController } from './message-broadcast.controller';
import { MessageBroadcastService } from './message-broadcast.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { BiMessage } from '../entity/bi-message.entity';
import { BroadcastMessage } from './entity/broadcast-message.entity';
import { BroadcastContact } from './entity/broadcast-contact.entity';
import { BroadcastInfoService } from './broadcast-info.service';
import { BiMessageRepository } from '../entity/repository/bi-message.repository';
import { BloodDonationUser } from './entity/blood-donation-users.entity';
import { BiMessageService, WhatsAppMetaService } from '@schemax-whatsapp/shared-services/whatsapp-api';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      BiMessage,
      BroadcastMessage,
      BroadcastContact,
      BloodDonationUser
    ])
  ],
  controllers: [MessageBroadcastController],
  providers: [MessageBroadcastService, ApplicationExceptionHandler, BroadcastInfoService,WhatsAppMetaService,BiMessageService]
})
export class MessageBroadcastModule {}
